export function getSvgDimensions(iconSvg: string): { width: number; height: number } {
  const parser = new DOMParser()
  const doc = parser.parseFromString(iconSvg, 'image/svg+xml')
  const svg = doc.querySelector('svg')

  if (svg) {
    const widthAttr = svg.getAttribute('width')
    const heightAttr = svg.getAttribute('height')
    const w = widthAttr ? parseFloat(widthAttr) : NaN
    const h = heightAttr ? parseFloat(heightAttr) : NaN
    if (!isNaN(w) && !isNaN(h)) return { width: w, height: h }

    const viewBox = svg.getAttribute('viewBox')
    if (viewBox) {
      const parts = viewBox.trim().split(/[\s,]+/)
      if (parts.length === 4) {
        const vw = parseFloat(parts[2])
        const vh = parseFloat(parts[3])
        if (!isNaN(vw) && !isNaN(vh)) return { width: vw, height: vh }
      }
    }
  }

  return { width: 24, height: 24 }
}
